import styled from 'styled-components';
import { fontWeight, FontWeightProps } from 'styled-system';

const FontWeight = styled.span<FontWeightProps>`
  ${fontWeight};
`;

export default FontWeight;
